import { ChatMessage } from '../chat/ChatMessage'
import { Team } from '../models/Team'

export class RatingChatMessage extends ChatMessage {
    selectedTeams: Team[] = []
    confirmed = false
    notes: { userId: number; note: string }[] = []
}
